import { RButton } from './RButton';
import { resolveNoContainer } from './resolve-no-container';
import { resolveRendersOwnElement } from './resolve-renders-own-element';
import { defaultAttributeValues } from './default-attribute-values';
import { attributeEditModeConfigs } from './attribute-edit-mode-configs';
import type {
  DisplayCardEntry,
  WidgetInstanceProps,
} from '@source-components-react/types';
import { ComponentIdentifiers } from '@source-components-react/component-identifiers';

export const displayCardEntry: DisplayCardEntry = {
  id: ComponentIdentifiers.rButton,
  resolveNoContainer,
  resolveRendersOwnElement,
  card: ({
    componentAttributes,
    styleProps,
    className,
    widgetInstanceProps,
    columnPath,
  }: {
    componentAttributes?: { [key: string]: any };
    styleProps?: { [key: string]: any };
    className?: string;
    widgetInstanceProps?: WidgetInstanceProps;
    columnPath?: string;
  }) => (
    <RButton
      componentAttributes={componentAttributes}
      styleProps={styleProps}
      className={className}
      widgetInstanceProps={widgetInstanceProps}
      columnPath={columnPath}
    />
  ),
  defaultAttributeValues,
  attributeEditModeConfigs,
};
